

export default {
  kategoriList: [],
  subKategoriList: [],
  totalTMRecords: 0,
  totalRecords: 0,
  totalKatRecords: 0,
  totalSubKatRecords: 0,
  totalLapRecords: 0
}
